import 'isomorphic-fetch'

import { redirectEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

import {
  ADD_NEW_REDIRECT,
  FETCH_REDIRECTS,
  REMOVE_REDIRECT_BY_ID,
  FETCH_ALL_REDIRECTS,
  GLOBAL_REDIRECT_UPDATE_STATUS,
  FETCH_REDIRECT_TO_EDIT
} from '../actionTypes'

export const fetchRedirectsList = params => async dispatch => {
  const { method, url } = redirectEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { redirects: rows, redirectsCount: rowsCount } = apiResponse
  dispatch({
    type: FETCH_REDIRECTS,
    payload: {
      rows,
      rowsCount
    }
  })
}

export const fetchAllRedirects = () => async dispatch => {
  const { method, url } = redirectEndpoint.init
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { allRedirects = [] } = apiResponse
  dispatch({
    type: FETCH_ALL_REDIRECTS,
    payload: {
      allRedirects
    }
  })
}
export const removeRedirectById = (redirectObjectId, accessToken) => async dispatch => {
  const { method, url } = redirectEndpoint.delete(redirectObjectId)
  const idToken = getIdToken()

  if (!idToken) {
    const errorResponse = {
      message: 'Authentication token is missing. Please log in again.',
      success: false
    }
    dispatch({
      type: REMOVE_REDIRECT_BY_ID,
      payload: errorResponse
    })
    return
  }

  const apiResponse = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    }
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => ({
      message: error.message,
      success: false
    }))
  const { deletedRedirect } = apiResponse

  dispatch({
    type: REMOVE_REDIRECT_BY_ID,
    payload: {
      deleteMessage: deletedRedirect?.acknowledged ? 'Redirect deleted successfully' : 'Error while deleting redirect',
      deleteStatus: deletedRedirect?.acknowledged,
      deletedRedirect
    }
  })
}

export const fetchRedirectById = redirectObjectId => async dispatch => {
  try {
    const { method, url } = redirectEndpoint.edit(redirectObjectId)
    const idToken = getIdToken()
    const apiResponse = await fetch(url, {
      headers: {
        Authorization: `Bearer ${idToken}`
      },
      method: method
    })
      .then(async response => await getApiResponseInJSON(response))
      .catch(error => console.error(error))
    dispatch({
      type: FETCH_REDIRECT_TO_EDIT,
      payload: {
        ...apiResponse
      }
    })
  } catch (error) {
    console.log(error)
  }
}

export const updateRedirect = (redirectObjectId, redirect, accessToken) => async dispatch => {
  try {
    const { method, url } = redirectEndpoint.update(redirectObjectId)
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify(redirect),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method: method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { message, success } = response
        dispatch({
          type: GLOBAL_REDIRECT_UPDATE_STATUS,
          payload: { message, success }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
    console.log(error)
  }
}

export const resetUpdateRedirectStatus = () => async dispatch => {
  dispatch({
    type: GLOBAL_REDIRECT_UPDATE_STATUS,
    payload: {
      message: '',
      success: false
    }
  })
}

export const addRedirect = (redirect, accessToken) => async dispatch => {
  try {
    const { method, url } = redirectEndpoint.add
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify({ redirect }),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { addedRedirect: { _id: newRedirectId }, message, success } = response
        dispatch({
          type: ADD_NEW_REDIRECT,
          payload: { newRedirectId, message, success }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
    console.log(error)
  }
}

export const resetRedirectsActionStatus = () => async dispatch => {
  dispatch({
    type: ADD_NEW_REDIRECT,
    payload: {
      error: false,
      message: '',
      success: false
    }
  })
}
